import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormObjectDescriptionListItems from '@/forms/objects/components/FormObjectDescriptionListItems';
import formFieldType, { formFieldText } from '@/forms/helper';
import events from '../../hooks/events';
import selectors from '../hooks/selectors';
import requestFieldComponents from '../helper';

const RequestObjectDescription = ({
  category,
  code,
  field,
  section,
}) => {
  const state = selectors.useFormFields({ category, code, section });
  const updateProperties = events.useUpdateRequestFieldsProperties(category, { code });

  const onValueChange = (parent, child, value) => {
    const properties = propertiesWithValue(parent, propertiesWithValue(child, value));
    updateProperties({ properties, fields: [parent.name, child.name], entity: section });
  };

  return (
    <List className={clsx('aridhia-form-object-description', field.code)}>
      <FormObjectDescriptionListItems
        canEdit={state.canEdit}
        category={category}
        code={code}
        component={(f) => requestFieldComponents[formFieldType(f)]}
        field={field}
        onChange={onValueChange}
        text={(parent, child) => formFieldText(state.request, child, 'fields.', parent)}
      />
    </List>
  );
};

export default RequestObjectDescription;
